export const UNIQUE_SEPERATOR = "&.|.&"
